// Module
var code = `<predicate predicates="\$ctrl.predicates"
           type="\$ctrl.type"
           ng-disabled="\$ctrl.ngDisabled">

  <select ng-options="ar.value as ar.label for ar in \$ctrl.inputDefinitions"
          ng-model="\$ctrl.inputDefinition"
          ng-change="\$ctrl.inputDefinitionChanged()"
          ng-disabled="\$ctrl.ngDisabled"
          required>
  </select>

  <select ng-model="\$ctrl.value"
          ng-disabled="\$ctrl.ngDisabled"
          ng-change="\$ctrl.valueChanged()"
          required>
    <option value="CURRENT_USER_ONLY">Only on logged in user (own account)</option>
  </select>
</predicate>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/predicates/user-predicate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;